import type { Template } from "@/types";

export const PO_07_H3_V4: Template[] = [
    {
        id: "po-07-h3v4-01",
        name: "PO 01 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 46, y: 143, width: 559, height: 350, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 501, width: 275, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 501, width: 275, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 143, width: 203, height: 267, rotation: 0, imageRotation: 0 },
            { id: "5", x: 767, y: 418, width: 203, height: 266, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 143, width: 202, height: 267, rotation: 0, imageRotation: 0 },
            { id: "7", x: 978, y: 418, width: 202, height: 266, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-02",
        name: "PO 02 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_02.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 64, y: 168, width: 210, height: 159, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 335, width: 210, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 282, y: 168, width: 318, height: 492, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 168, width: 354, height: 492, rotation: 0, imageRotation: 0 },
            { id: "5", x: 64, y: 502, width: 210, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1062, y: 168, width: 174, height: 242, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1062, y: 418, width: 174, height: 242, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-03",
        name: "PO 03 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 37, y: 131, width: 583, height: 366, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 37, y: 505, width: 288, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 333, y: 505, width: 287, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 131, width: 435, height: 565, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1121, y: 131, width: 140, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1121, y: 322, width: 140, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1121, y: 513, width: 140, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-04",
        name: "PO 04 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 152, y: 78, width: 344, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 152, y: 307, width: 344, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 152, y: 536, width: 344, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 728, y: 78, width: 243, height: 335, rotation: 0, imageRotation: 0 },
            { id: "5", x: 728, y: 421, width: 243, height: 335, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 78, width: 242, height: 335, rotation: 0, imageRotation: 0 },
            { id: "7", x: 979, y: 421, width: 242, height: 335, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-05",
        name: "PO 05 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 59, y: 149, width: 529, height: 349, rotation: 0, imageRotation: 0 },
            { id: "2", x: 59, y: 506, width: 261, height: 172, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 506, width: 261, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 783, y: 149, width: 187, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 783, y: 418, width: 187, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 149, width: 187, height: 261, rotation: 0, imageRotation: 0 },
            { id: "7", x: 978, y: 418, width: 187, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-06",
        name: "PO 06 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 90, y: 78, width: 469, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 385, width: 231, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 385, width: 230, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 90, y: 534, width: 151, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 249, y: 534, width: 151, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 408, y: 534, width: 151, height: 214, rotation: 0, imageRotation: 0 },
            { id: "7", x: 739, y: 78, width: 469, height: 671, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-07",
        name: "PO 07 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_07.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 90, y: 78, width: 231, height: 142, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 78, width: 230, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 90, y: 227, width: 469, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 90, y: 534, width: 151, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 249, y: 534, width: 151, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 408, y: 534, width: 151, height: 214, rotation: 0, imageRotation: 0 },
            { id: "7", x: 739, y: 78, width: 469, height: 671, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-08",
        name: "PO 08 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 195, width: 645, height: 436, rotation: 0, imageRotation: 0 },
            { id: "2", x: 653, y: 195, width: 319, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 980, y: 195, width: 318, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 410, width: 156, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 817, y: 410, width: 155, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 980, y: 410, width: 155, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1143, y: 410, width: 155, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-09",
        name: "PO 09 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 212, width: 272, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 280, y: 212, width: 179, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 280, y: 349, width: 179, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 280, y: 486, width: 179, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 467, y: 212, width: 272, height: 402, rotation: 0, imageRotation: 0 },
            { id: "6", x: 747, y: 212, width: 272, height: 402, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1027, y: 212, width: 271, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-10",
        name: "PO 10 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 212, width: 272, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 280, y: 212, width: 272, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 560, y: 212, width: 272, height: 402, rotation: 0, imageRotation: 0 },
            { id: "4", x: 840, y: 212, width: 271, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1119, y: 212, width: 179, height: 129, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1119, y: 349, width: 179, height: 129, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1119, y: 486, width: 179, height: 128, rotation: 0, imageRotation: 0 }
        ],
    }
];